import { wencesApi } from "@/api/wencesApi";

let defaultTitle = "ExportAI";

const updatePageTitle = async () => {
  try {
    // Intentar obtener la configuración del negocio
    const response = await wencesApi.get("/api/settings");
    console.log(response);
    if (
      response.data &&
      response.data.success &&
      response.data.data &&
      response.data.data.siteName
    ) {
      document.title = response.data.data.siteName;
    } else {
      document.title = defaultTitle;
    }
  } catch (error) {
    // Si hay error (usuario no autenticado o error de red), usar título por defecto
    document.title = defaultTitle;
  }
};

const setDefaultTitle = (title) => {
  defaultTitle = title;
  document.title = title;
};

export { updatePageTitle, setDefaultTitle };
